export default {
  methods: {
    /**
     *
     * @use declOfNum(count, ['найдена', 'найдено', 'найдены']);
     * @param number {Number}
     * @param titles {Array}
     * @returns {*}
     */
    declOfNum(number, titles) {
      const cases = [2, 0, 1, 1, 1, 2];
      return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    },
    declOfDays(number) {
      return this.declOfNum(number, ['день', 'дня', 'дней']);
    }
  }
}
